<template>
  <div class="health-info">
    <div class="health-info-header">
      <div class="health-info-title">功能信息</div>
      <!-- <div class="health-info-checkbox" @click="onSelect" v-if="isRead">
        <div class="health-info-icon">
          <img v-if="allOk" src="@/assets/selected.png" />
          <img v-else src="@/assets/unselected.png" />
        </div>
        <div class="all-title">功能完好</div>
      </div> -->
    </div>
    <div class="health-info-list" v-for="item in orderTagList" :key="item.id">
      <div class="health-info-list-title">{{ item.name }}</div>
      <div class="health-info-list-line"></div>
      <div class="scroll-view" style="overflow-x: auto; display: flex;">
        <div v-for="tagItem in item.children" :key="tagItem.id"  >
        <div
            class="scroll-view-item"
            :class="{ active: tagItem.selected }"
            @click="onSelect(tagItem)"
            v-show="tagItem.selected || isRead"
          >

            {{ tagItem.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderFunctionTag",
  props: {
    orderTagList: {
      type: Array,
      default: () => [],
      observer(val) {
        if (val.length) {
          let isGoodList = [];
          val.forEach(e => {
            e.children.forEach(e1 => {
              if (e1.isGood === 1) {
                isGoodList.push(true);
              }
            });
          });

          let okList = [];
          val.forEach(item => {
            item.children.forEach(item1 => {
              if (item1.isGood === 1 && item1.selected) {
                okList.push(true);
              }
            });
          });

          this.allOk = okList.length === isGoodList.length && isGoodList.length >= val.length && isGoodList.length !== 0;
        }
      }
    },
    isRead: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      allOk: false
    };
  },
  methods: {
    onSelect(tagItem) {
      const id = tagItem.id;
      this.$emit('select', { id });
    }
  }
};
</script>

<style scoped>
.health-info {
/* margin: 0.8rem 0; */
}

.health-info-header {
border-bottom: 0.04rem #e1e1e1 solid;
padding: 0.8rem 0;
display: flex;
justify-content: space-between;
font-size: 0.8rem;
font-family: Source Han Sans CN;
font-weight: 500;
line-height: 1.53rem;
color: #171819;
}

.health-info-checkbox {
display: flex;
align-items: center;
}

.health-info-icon {
width: 1.33rem;
height: 1.33rem;
margin-right: 0.27rem;
}

.health-info-icon image {
width: 1.33rem;
height: 1.33rem;
}

.health-info-list {
display: flex;
align-items: center;
justify-content: flex-start;
border-bottom: 0.04rem solid #E3E3E3;
padding: 0.52rem 0;
}

.health-info-list-title {
flex-shrink: 0;
position: relative;
/* max-height: 1.6rem; */
overflow-y: hidden;
width: 4rem;
word-wrap: break-word;
font-size: 0.8rem;
font-family: PingFang SC;
font-weight: 400;
line-height: 1.53rem;
color: #8B8B8B;
}


.hide-title {
visibility: hidden;
}

.health-info-list-line {
width: 0.04rem;
height: 0.87rem;
background-color: #999;
margin: 0 0.4rem 0 1.45rem;
}

.scroll-view {
display: flex;
flex-wrap: nowrap;
height: 2.4rem;
overflow: scroll;
}

.scroll-view-item {
  height: 1.6rem;
  display: inline-block;
  width: auto;
  padding: 0 0.8rem;
  border: 0.04rem solid #e1e1e1;
  background-color: rgba(238, 238, 238, .6);
  margin: 0.4rem 0;
  margin-right: 0.2rem;
  flex-shrink: 0;
  white-space: nowrap;

  font-size: 0.8rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 1.53rem;
  color: #343434;
}
.scroll-view-item.active {
border: 0.04rem solid rgba(54,111,254,1);
background-color: rgba(54,111,254,.2);
color: rgba(54,111,254,1);
}

.all-title{
font-size: 0.8rem;
font-family: PingFang SC;
font-weight: 400;
line-height: 1.53rem;
color: #171819;
}
</style>